<mat-card>
    <div class="subheader">
        <h3 matSubheader>OAuth Clients</h3>
        <button mat-mini-fab color="primary" aria-label="Create" (click)="createClient()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
    <table class="tokens-table mat-elevation-z3">
        <thead>
            <tr>
                <th>Client ID</th>
                <th class="grow">Name</th>
                <th>Secret</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let element of oAuthDataSource">
                <td>{{element.id}}</td>
                <td class="grow">{{element.name}}</td>
                <td>{{element.secret}}</td>
                <td class="text-right">
                    <button mat-mini-fab color="warn" aria-label="Delete" (click)="deleteClient(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button mat-mini-fab color="primary" aria-label="Edit" (click)="editClient(element)">
                        <mat-icon>edit</mat-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="oAuthLoading">
                <td [attr.colspan]="oAuthDisplayedColumns.length">Loading, please wait...</td>
            </tr>
            <tr *ngIf="!oAuthLoading && (oAuthDataSource === undefined || oAuthDataSource.length === 0)">
                <td [attr.colspan]="oAuthDisplayedColumns.length">No records found.</td>
            </tr>
        </tbody>
    </table>

    <h3 matSubheader>Authorized Applications</h3>

    <table class="tokens-table mat-elevation-z3">
        <thead>
            <tr>
                <th class="grow">Name</th>
                <th>Scopes</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let element of applicationsDataSource">
                <td class="grow">{{element.client.name}}</td>
                <td>{{element.scopes.join(', ')}}</td>
                <td class="text-right">
                    <button mat-mini-fab color="warn" aria-label="Revoke" (click)="revokeApplication(element)">
                        <mat-icon>block</mat-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="applicationsLoading">
                <td [attr.colspan]="applicationsDisplayedColumns.length">Loading, please wait...</td>
            </tr>
            <tr *ngIf="!applicationsLoading && (applicationsDataSource === undefined || applicationsDataSource.length === 0)">
                <td [attr.colspan]="applicationsDisplayedColumns.length">No records found.</td>
            </tr>
        </tbody>
    </table>

    <div class="subheader">
        <h3 matSubheader>Personal Access Tokens</h3>
        <button mat-mini-fab color="primary" aria-label="Create" (click)="createPersonalAccessToken()">
            <mat-icon>add</mat-icon>
        </button>
    </div>

    <table class="tokens-table mat-elevation-z3">
        <thead>
            <tr>
                <th class="grow">Name</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let element of personalDataSource">
                <td class="grow">{{element.name}}</td>
                <td class="text-right">
                    <button mat-mini-fab color="warn" aria-label="Delete" (click)="deletePersonalAccessToken(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="personalLoading">
                <td [attr.colspan]="personalDisplayedColumns.length">Loading, please wait...</td>
            </tr>
            <tr *ngIf="!personalLoading && (personalDataSource === undefined || personalDataSource.length === 0)">
                <td [attr.colspan]="personalDisplayedColumns.length">No records found.</td>
            </tr>
        </tbody>
    </table>
</mat-card>